import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { PromoBanner } from "./components/PromoBanner";
import { Marquee } from "./components/Marquee";
import { Stats } from "./components/Stats";
import { HowItWorks } from "./components/HowItWorks";
import { AboutTeam } from "./components/AboutTeam";
import { Simulator } from "./components/Simulator";
import { Testimonials } from "./components/Testimonials";
import { Media } from "./components/Media";
import { AppShowcase } from "./components/AppShowcase";
import { ClubVideos } from "./components/ClubVideos";
import { Connect } from "./components/Connect";
import { Faq } from "./components/Faq";
import { Services } from "./components/Services";
import { Licenciado } from "./components/Licenciado";
import { LeadForm } from "./components/LeadForm";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { ChatWidget } from "./components/ChatWidget";
import { CookieBanner } from "./components/CookieBanner";
import { LeadPopup } from "./components/LeadPopup";
import Admin from "./pages/Admin";
import Privacidade from "./pages/Privacidade";
import Energia from "./pages/services/Energia";
import Empresas from "./pages/services/Empresas";
import Solar from "./pages/services/Solar";
import Telecom from "./pages/services/Telecom";
import Seguros from "./pages/services/Seguros";
import Mob from "./pages/services/Mob";
import SejaLicenciado from "./pages/services/SejaLicenciado";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#04120E] min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <PromoBanner />
        <Marquee />
        <Stats />
        <HowItWorks />
        <AboutTeam />
        <Simulator />
        <Testimonials />
        <Media />
        <AppShowcase />
        <ClubVideos />
        <Connect />
        <Faq />
        <Services />
        <Licenciado />
        <LeadForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <CookieBanner />
      <LeadPopup />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/energia" element={<Energia />} />
          <Route path="/energia-empresas" element={<Empresas />} />
          <Route path="/energia-solar" element={<Solar />} />
          <Route path="/telecom" element={<Telecom />} />
          <Route path="/seguros" element={<Seguros />} />
          <Route path="/mob" element={<Mob />} />
          <Route path="/seja-licenciado" element={<SejaLicenciado />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
